const defaultState = '';

export default (state = defaultState, action) => {
    const { type, payload } = action;

    switch (type) {
        case "searchInput/update":
            return payload;
        case "searchInput/clear":
        case "REDUX/CLEAR":
            return defaultState;
        default:
            return state;
    }
};